module.exports = __webpack_public_path__ + "images/category_lp/watch/point-1_93ef8437564aa00a1a030e84adc152e1.png";